import { render, staticRenderFns } from "./statisticPromotion.vue?vue&type=template&id=5de8d4d0&scoped=true&"
import script from "./statisticPromotion.vue?vue&type=script&lang=js&"
export * from "./statisticPromotion.vue?vue&type=script&lang=js&"
import style0 from "./statisticPromotion.vue?vue&type=style&index=0&id=5de8d4d0&scoped=true&lang=css&"
import style1 from "./statisticPromotion.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de8d4d0",
  null
  
)

export default component.exports